import React, { createContext, useContext, useState, useEffect } from 'react';

const UIContext = createContext();

export const UIProvider = ({ children }) => {

    const [activeSuperTab, setActiveSuperTab] = useState('gameScenario');
    const [activeTab, setActiveTab] = useState('situation');
    const [showSuperTab, setShowSuperTab] = useState(false);
    const [showTab, setShowTab] = useState(false);
    const [activeChapterNumber, setActiveChapterNumber] = useState(null);
    const [focusMode, setFocusMode] = useState(false);

    
 

    const value = {
        activeTab,
        setActiveTab,
        activeSuperTab,
        setActiveSuperTab,
        activeChapterNumber,
        setActiveChapterNumber,
        focusMode,
        setFocusMode,
        
        //Below should not be in UI Context
        showTab,
        setShowTab,
        showSuperTab,
        setShowSuperTab,

    };

    useEffect(() => {
        if (activeSuperTab?.startsWith('chapter')) {
          const newChapterNumber = parseInt(activeSuperTab.replace('chapter', ''), 10);
          setActiveChapterNumber(newChapterNumber);
        }
      }, [activeSuperTab]);

    return <UIContext.Provider value={ value }>{children}</UIContext.Provider>;
};

export const useUI = () => useContext(UIContext);
